// extracted by mini-css-extract-plugin
var _1 = "TableModalSearch-moduleskeleton__sM2Bh Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "skeleton" }
